const syncGalleryThumbState = (gallery, mediaId) => {
  if (!gallery || !mediaId) return;
  gallery.querySelectorAll("[data-thumb]").forEach((thumb) => {
    const active = String(thumb.dataset.mediaId) === String(mediaId);
    thumb.classList.toggle("active", active);
    thumb.setAttribute("aria-selected", active ? "true" : "false");
  });
};

const setMainGalleryImage = (mainView, src, alt) => {
  if (!mainView || mainView.tagName !== "IMG" || !src) return;
  // Shopify image_tag renders srcset/sizes; clear them so runtime src swap is respected.
  mainView.removeAttribute("srcset");
  mainView.removeAttribute("sizes");
  mainView.src = src;
  if (alt) mainView.alt = alt;
};

const bindGallery = (gallery) => {
  if (!gallery || gallery.dataset.mediaLayout === "stack") return;
  const mainView =
    gallery.querySelector("[data-gallery-main]") ||
    gallery.querySelector("[data-gallery-stage] img") ||
    gallery.querySelector(".pdp-gallery__stage img");
  if (!mainView) return;

  const thumbs = Array.from(gallery.querySelectorAll("[data-thumb]"));
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const src = thumb.dataset.image;
      const alt = thumb.dataset.alt || "";
      const mediaId = thumb.dataset.mediaId;
      if (!src || mainView.tagName !== "IMG") return;
      setMainGalleryImage(mainView, src, alt);
      if (mediaId) {
        mainView.dataset.mediaId = mediaId;
        syncGalleryThumbState(gallery, mediaId);
      }
    });
  });
};

document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
  bindGallery(gallery);
});

document.querySelectorAll("form.product-form").forEach((form) => {
  const variantSelect = form.querySelector('select[name="id"]');
  const layout = form.closest(".pdp-layout");
  const gallery = layout?.querySelector("[data-product-gallery]");
  const mainView =
    gallery?.querySelector("[data-gallery-main]") ||
    gallery?.querySelector("[data-gallery-stage] img") ||
    gallery?.querySelector(".pdp-gallery__stage img");
  if (!variantSelect) return;

  variantSelect.addEventListener("change", () => {
    const selected = variantSelect.options[variantSelect.selectedIndex];
    if (!selected) return;

    // 1) Update price (green price on PDP)
    if (layout) {
      const priceText = selected.dataset.price;
      if (priceText) {
        const priceEl = layout.querySelector(".pdp-price__current");
        if (priceEl) priceEl.textContent = priceText;
        const stickyPriceEl = layout.querySelector(".pdp-sticky-bar__price");
        if (stickyPriceEl) stickyPriceEl.textContent = priceText;
      }

      const skuText = selected.dataset.sku;
      if (skuText) {
        const skuInline = layout.querySelector(".pdp-sku__val");
        if (skuInline) skuInline.textContent = skuText;
      }

      // 1c) Dynamic remaining stock message for tracked inventory variants
      const urgencyEl = layout.querySelector("[data-pdp-urgency]");
      if (urgencyEl) {
        const isTracked = String(selected.dataset.inventoryTracked) === "true";
        const qty = Number.parseInt(selected.dataset.inventoryQty || "0", 10);
        const prefix = urgencyEl.dataset.prefix || "Only";
        const suffix = urgencyEl.dataset.suffix || "left";
        const isAvailable = String(selected.dataset.available) === "true";
        urgencyEl.classList.remove(
          "pdp-pay-note--critical",
          "pdp-pay-note--low",
          "pdp-pay-note--healthy",
          "pdp-pay-note--soldout",
          "pdp-pay-note--neutral"
        );

        if (isTracked && isAvailable && qty > 0) {
          urgencyEl.textContent = `${prefix} ${qty} ${suffix}`;
          if (qty <= 3) urgencyEl.classList.add("pdp-pay-note--critical");
          else if (qty <= 10) urgencyEl.classList.add("pdp-pay-note--low");
          else urgencyEl.classList.add("pdp-pay-note--healthy");
          urgencyEl.hidden = false;
        } else if (isTracked && !isAvailable) {
          urgencyEl.textContent = "Sold out";
          urgencyEl.classList.add("pdp-pay-note--soldout");
          urgencyEl.hidden = false;
        } else {
          // For non-tracked variants, keep the fallback copy set in Liquid.
          urgencyEl.classList.add("pdp-pay-note--neutral");
          urgencyEl.hidden = false;
        }
      }

      const stickyBtn = layout.querySelector(".pdp-sticky-bar__btn[data-ajax-add]");
      if (stickyBtn) stickyBtn.dataset.variantId = selected.value;

      // 1b) Toggle availability state for selected variant
      const isAvailable = String(selected.dataset.available) === "true";
      const mainAtcBtn = form.querySelector("[data-atc-main]");
      if (mainAtcBtn) {
        mainAtcBtn.disabled = !isAvailable;
        mainAtcBtn.textContent = isAvailable
          ? mainAtcBtn.dataset.atcDefaultLabel || "Add to cart"
          : mainAtcBtn.dataset.atcSoldoutLabel || "Sold out";
      }

      if (stickyBtn) {
        stickyBtn.disabled = !isAvailable;
        stickyBtn.textContent = isAvailable
          ? stickyBtn.dataset.atcDefaultLabel || "Add to cart"
          : stickyBtn.dataset.atcSoldoutLabel || "Sold out";
      }
    }

    // 2) Update gallery image (only when gallery exists + not stack)
    if (gallery && gallery.dataset.mediaLayout !== "stack" && mainView) {
      const featuredSrc = selected.dataset.featuredImage || "";
      const featuredAlt = selected.dataset.featuredAlt || "";
      const mediaId = selected.dataset.featuredMediaId || "";
      if (!featuredSrc) return;

      setMainGalleryImage(mainView, featuredSrc, featuredAlt);
      if (mediaId) {
        mainView.dataset.mediaId = mediaId;
        syncGalleryThumbState(gallery, mediaId);
      }
    }
  });
});

document.querySelectorAll(".pdp-qty").forEach((wrap) => {
  const input = wrap.querySelector(".pdp-qty__input");
  if (!input) return;
  wrap.querySelectorAll("[data-pdp-qty]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const delta = Number.parseInt(btn.getAttribute("data-pdp-qty") || "0", 10);
      let v = Number.parseInt(String(input.value), 10) || 1;
      const min = Number.parseInt(input.getAttribute("min") || "1", 10);
      const max = Number.parseInt(input.getAttribute("max") || "99", 10);
      v = Math.min(max, Math.max(min, v + delta));
      input.value = String(v);
    });
  });
});

// PDP tabs: accessible switcher for product specs + "Why riders" content.
document.querySelectorAll("[data-pdp-tabs]").forEach((root) => {
  const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
  if (!tabs.length) return;

  const activate = (tab) => {
    tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle("is-active", isActive);
      t.setAttribute("aria-selected", String(isActive));
    });

    const panelId = tab.getAttribute("aria-controls");
    root.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
      const isPanelActive = panel.getAttribute("id") === panelId;
      panel.classList.toggle("is-active", isPanelActive);
      if (!isPanelActive) panel.hidden = true;
      else panel.hidden = false;
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => activate(tab));
  });

  // Keyboard: Left/Right (or Up/Down) cycles tabs.
  root.addEventListener("keydown", (e) => {
    const activeEl = root.querySelector('[role="tab"][aria-selected="true"]');
    if (!activeEl) return;
    const activeIndex = tabs.indexOf(activeEl);
    if (activeIndex < 0) return;

    const isRight = e.key === "ArrowRight" || e.key === "ArrowDown";
    const isLeft = e.key === "ArrowLeft" || e.key === "ArrowUp";
    if (!isRight && !isLeft) return;

    e.preventDefault();
    const nextIndex = isRight ? (activeIndex + 1) % tabs.length : (activeIndex - 1 + tabs.length) % tabs.length;
    const next = tabs[nextIndex];
    activate(next);
    next.focus({ preventScroll: true });
  });
});
